import React, { useState } from 'react';
import { TouchableOpacity } from 'react-native';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';
import { ProjectMemberRole } from '@graphql/generated';
import theme from '@themes/theme';

export const ProjectRoleSelectorWeb = ({
  onRoleSelect,
  selectedRole,
  isOwner = true,
  onRemove,
  showRemove = false,
}: {
  isOwner?: boolean;
  onRoleSelect: (role: ProjectMemberRole) => void;
  selectedRole: ProjectMemberRole;
  onRemove?: () => void;
  showRemove?: boolean;
}) => {
  const role1 = {
    title: 'Admin',
    id: ProjectMemberRole.Admin,
  };
  const role2 = {
    title: 'Editor',
    id: ProjectMemberRole.Editor,
  };
  const role3 = {
    title: 'Viewer',
    id: ProjectMemberRole.Viewer,
  };
  const roleOptions = isOwner ? [role1, role2, role3] : [role2, role3];

  const handleRolePress = (roleId: ProjectMemberRole) => {
    onRoleSelect?.(roleId);
  };

  const [isHoveredRemove, setIsHoveredRemove] = useState(false);

  return (
    <Box
      width={120}
      py='xxs'
      style={{
        borderRadius: 8,
        borderWidth: 1,
        borderColor: theme.colors.grey02,
      }}>
      {roleOptions.map(({ title, id }) => {
        const [isHovered, setIsHovered] = useState(false);
        return (
          <TouchableOpacity
            key={id}
            onPress={() => handleRolePress(id)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Box
              p='xs'
              flex={1}
              flexDirection='row'
              height={32}
              alignItems='center'
              backgroundColor={isHovered ? 'grey01' : 'white'}>
              <Text
                flex={1}
                ml='xs'
                accessibilityLabel={title}
                variant='webBodySecondary'
                color='textPrimary'
                numberOfLines={1}>
                {title}
              </Text>
              {selectedRole === id && (
                <Icon name='Check' color='greenSecondary' variant='s' />
              )}
            </Box>
          </TouchableOpacity>
        );
      })}
      {isOwner && showRemove && (
        <Box
          style={{
            borderTopWidth: 1,
            borderTopColor: theme.colors.grey02,
          }}>
          <TouchableOpacity
            key={ProjectMemberRole.Owner}
            onPress={() => onRemove?.()}
            onMouseEnter={() => setIsHoveredRemove(true)}
            onMouseLeave={() => setIsHoveredRemove(false)}>
            <Box
              p='xs'
              flex={1}
              flexDirection='row'
              height={32}
              alignItems='center'
              backgroundColor={isHoveredRemove ? 'grey01' : 'white'}>
              <Text
                flex={1}
                ml='xs'
                accessibilityLabel='Remove'
                variant='webBodySecondary'
                color='alertRed'
                numberOfLines={1}>
                Remove
              </Text>
            </Box>
          </TouchableOpacity>
        </Box>
      )}
    </Box>
  );
};
